import { action } from 'mobx'
import axios from "axios/index";
import {Common as util} from "../utils/common";
import gql from "../utils/gql";


export class Widget {


  // 위젯 행동 퍼널 (입점사 대면) — widgetEventLog 집계. store_id 는 백엔드에서 인증 토큰으로 스코프.
  @action getWidgetFunnel = (data, cb) => {

    let property = ['store_id', 'shopNo', 'startDate', 'endDate', 'widget', 'platformProductId', 'page'];
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getWidgetFunnel',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if (res.status === 200) {
          const result = res.data.data ? res.data.data[params.operation] : null;
          const d = result ? result.data : null; // {data: ...} 언래핑
          if (typeof cb === 'function') cb(d);
          else return d;
        }
      })
      .catch(function (error) {
        console.log(error);
        if (typeof cb === 'function') cb(null);
        return error;
      });
  };

  @action getWidgetList = (data, cb) => {

    let property = ['store_id', 'shopNo', 'mode', 'limit', 'page', 'sort', 'searchParams', 'selecting', 'type'];
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getWidgetList',
      variables: variables,
      getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }
        }

      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };

  @action getWidgetInReviewList = (data, cb) => {

    let property = ['widget_id'];
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getWidgetInReviewList',
      variables: variables,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if(res.status === 200) {
            if(typeof cb === 'function') {
              cb(res.data.data[params.operation]);
            }
            else {
              return res.data.data[params.operation];
            }
          }

        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };


  @action updateWidget = (data, cb) => {
    if(data._id) data.id = data._id;
    let property = ['id', 'shopNo', 'store_id', 'title', 'isTitleDis', 'type', 'reviewType', 'selecting', 'displayArea', 'row', 'col', 'isAutoPlay', 'dataPer', 'isDisplay', 'head', 'style', 'display', 'slideDelay', 'slidesToScroll', 'mobileSlidesPerView']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'updateWidget',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    axios.post('/', gpqParams)
      .then(function (res) {
        if(typeof cb === 'function') {
          cb(res.data.data[params.operation]);
        }
        else {
          return res.data.data[params.operation];
        }

      })
      .catch(function (error) {
        if(typeof cb === 'function') {
          cb(error)
        }
        return error;
      });
  };


  @action updateWidgetInReview = (data, cb) => {

    let params = {
      type: 'mutation',
      operation: 'updateWidgetInReview',
      variables: data,
      getData: 'data'
    };
    const gpqParams = gql(params);

    axios.post('/', gpqParams)
        .then(function (res) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };

  @action updateWidgetInReviewOrder = (data, cb) => {

    let params = {
      type: 'mutation',
      operation: 'updateWidgetInReviewOrder',
      variables: data,
      getData: 'data'
    };
    const gpqParams = gql(params);

    axios.post('/', gpqParams)
        .then(function (res) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };

  @action removeWidgetInReview = (data, cb) => {

    let params = {
      type: 'mutation',
      operation: 'removeWidgetInReview',
      variables: data,
      getData: 'data'
    };
    const gpqParams = gql(params);

    axios.post('/', gpqParams)
        .then(function (res) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };

  @action removeWidget = (data, cb) => {
    if(data._id) data.id = data._id;
    let property = ['id', 'store_id']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'removeWidget',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    axios.post('/', gpqParams)
      .then(function (res) {
        if(typeof cb === 'function') {
          cb(res.data.data[params.operation]);
        }
        else {
          return res.data.data[params.operation];
        }

      })
      .catch(function (error) {
        if(typeof cb === 'function') {
          cb(error)
        }
        return error;
      });
  };

}
